module.exports = __webpack_public_path__ + "assets/img/jx.d6707af0.jpg";